// extracted by mini-css-extract-plugin
module.exports =  {"heading":"ToXkuTwJzTrgG2Bx72b9","subheading":"suyj0Fd4DV7uAVPos4Fw","btn":"PvmlBXn0h2CJJJY9GtcZ"};